













import Vue from "vue";

import { TranslatedExpression } from "@/models";

interface Props {
  value: string;
  label?: TranslatedExpression;
}

export default Vue.extend<Props>({
  name: "BaseInputTextArea",
  functional: true,
  props: {
    value: { type: String, required: true },
    label: { type: Object, required: false }
  }
});
